import { Label } from '@cian/ui-kit/label';
import { IconProductCianLogo16 } from '@cian/ui-kit-design-tokens/icons';
import React, { memo } from 'react';

export const OnlyCianBadgeComponent: React.FC = () => {
  return (
    <Label
      background="surface-main-default"
      color="accent-main-primary"
      icon={<IconProductCianLogo16 color="accent-main-primary" />}
      data-mark="OnlyCianBadge"
    >
      Только на Циан
    </Label>
  );
};

OnlyCianBadgeComponent.displayName = 'OnlyCianBadge';

export const OnlyCianBadge = memo(OnlyCianBadgeComponent);
